import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './ReportADIDIssuesForm.css';
import axios from '../../../axios-local-api';
import Box from '../../../hoc/Box/Box';
import TimeSelect from '../../../components/UI/TimeSelect/TimeSelect';
import WeekDays from '../../../components/UI/WeekDays/WeekDays';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
import Success from '../../../components/UI/Success/Success';
import Error from '../../../components/UI/Error/Error';
import Modal from '../../../components/UI/Modal/Modal';
import {
  updateObject,
  checkValidity
} from '../../../shared/utility';
import { timingSafeEqual } from 'crypto';

const TOTAL_NOTES_LENGTH = 140;

class ReportADIDIssuesForm extends Component {
  constructor(props) {
    super(props);
    //console.log('ReportADIDIssuesForm.constructor')
    this.state = {
      issueType: null,
      notes: ''
    }

  }

  componentDidMount() {
    //console.log('ReportADIDIssuesForm.componentDidMount')
  }

  addFormHandler = (event) => {
    let incorrectProperty = '';
    if(this.state.issueType === 'INCORRECT_ICON_ASSIGNED') {
      incorrectProperty = this.props.iconUrl;
    } else if(this.state.issueType === 'INCORRECT_DEVICE_MODEL') {
      incorrectProperty = this.props.deviceModel;
    }
    // console.log('incorrectProperty', incorrectProperty);
    this.props.onReportAdidIssue(this.state.issueType, this.props.devMac, this.props.deviceName, incorrectProperty, this.state.notes);
    this.confirmModalCancelHandler();
    event.preventDefault();
    //console.log("form submitted");
    // this.props.onSubmit( 'assign a port for port forwarding', formVals)
    // this.props.onOpenModal('change this IP Reservation')
  }

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  }

 closeModal = ()=>{
  this.props.closeModal();
 }

 onChangeIssueType = (e) => {
    this.setState({
      issueType: e.currentTarget.value
    });
 }

 onChangeNotes = (e) => {
  this.setState({
    notes: e.currentTarget.value
  });
}

validateForm = () => {
  if(this.state.issueType === null) {
    return false;
  }
  return true;
}

  render() {
    //console.log("st",this.state.startTime)
    //console.log("ReportADIDIssuesForm.render",this.props,this.state);
    let form = (
      <div className={classes.AdidModalStyling}>


        <Box>


          <div className={classes.Input}>
            <div style={{ margin: '10px 0px 5px 10px', color: 'black' }}>Please select an issue:</div>
            <div style={{ marginBottom: '10px', display: 'flex',alignItems: 'center', color: 'black' }}>
              <input style={{ cursor: 'pointer' }} id = 'IncorrectIconAssigned' aria-label={"Incorrect Device Model Radio Button"}
                        type='radio' checked= {this.state.issueType === 'INCORRECT_ICON_ASSIGNED'} name='issueType' value='INCORRECT_ICON_ASSIGNED' onChange={this.onChangeIssueType}/>
              <span> Incorrect Icon Assigned </span>
            </div>
            <div style={{ display: 'flex',alignItems: 'center', color: 'black' }} >
              <input style={{ cursor: 'pointer' }} id = 'IncorrectDeviceModel' aria-label={"Incorrect Device Model Radio Button"}
                        type='radio' checked= {this.state.issueType === 'INCORRECT_DEVICE_MODEL'} name='issueType' value='INCORRECT_DEVICE_MODEL' onChange={this.onChangeIssueType}/>
              <span>Incorrect Device Model</span>
            </div>
          </div>
          <label style={{ color: 'red' }}>  </label>
        </Box>


        <Box>
          <div className={[classes.showDesktop,classes.BodyRow].join(' ')} style={{ flexDirection: 'column', marginTop: '2rem', marginLeft: '10px' }}>
          <div className={classes.showDesktop} style={{ justifyContent: 'space-between', color: 'black' }}>
            <span>Notes (Optional)</span>
            <span>Remaining Characters:{TOTAL_NOTES_LENGTH - this.state.notes.length}</span>
          </div>
          <textarea id = 'Notes' style={{ height: '100px', resize: 'none' }} onChange={this.onChangeNotes} value={this.state.notes} maxLength = {TOTAL_NOTES_LENGTH}/>
           {/* <input type = 'textarea' onChange={this.onChangeNotes}></input>  */}

          </div>
        </Box>

        <Box>
          <div className={[classes.showMobile,classes.BodyRow].join(' ')} style={{ flexDirection: 'column', marginTop: '2rem', marginLeft: '10px' }}>
          <div style={{  justifyContent: 'space-between', color: 'black' }}>
            <span style={{ float:'left' }}>Notes (Optional)</span>
            <span style={{ float:'left' }}>Remaining Characters:{TOTAL_NOTES_LENGTH - this.state.notes.length}</span>
          </div>
          <textarea id = 'Notes' style={{ height: '100px', resize: 'none' }} onChange={this.onChangeNotes} value={this.state.notes} maxLength = {TOTAL_NOTES_LENGTH}/>
           {/* <input type = 'textarea' onChange={this.onChangeNotes}></input>  */}

          </div>
        </Box>

        <Box>
        <div className = {classes.Err}>{}</div>
        <div className={classes.ButtonRow}>
        <button
              id="cancelschedule"
              className={classes.CancelButton}
              onClick={this.closeModal}
              btnType="Success">
              Cancel</button>
            <button
              id="saveschedule"
              className={classes.Button}
              style={this.state.issueType === null ? { backgroundColor:'#D8DDE6',color:'#63738A' }:{ backgroundColor:'#0073d1',color:'#fff' }}
              onClick={this.addFormHandler}
              disabled={!this.validateForm()}
              btnType="Success">
              Submit</button>

          </div>


        </Box>
      </div>
    );

    if (this.props.loading) {
      form = <Spinner />;
    }


    return (
      <div className={classes.CreatePauseScheduleForm}>
        <span id = 'X' onClick={this.closeModal} style={{ position: 'absolute',right: 0, top: '-24px', color: '#555555', cursor: 'pointer' }}>X</span>

           <h3 style={{ textAlign: 'center', color: 'black' }}>Report Identification Issue</h3>
           {form}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {

  }
};

const mapDispatchToProps = dispatch => {
  return {
    onReportAdidIssue: (issueType, devMac, deviceName, incorrectProperty, message) => { dispatch(actions.reportAdidIssue( issueType, devMac, deviceName, incorrectProperty, message)) }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ReportADIDIssuesForm, axios));
